import { ONLINE_PAYMENT_PAGE as dict } from '@/resources/dict'
import creditIcon from '@/assets/imgs/icon-credit.svg'
import pixIcon from '@/assets/imgs/icon-pix.svg'
import checkIcon from '@/assets/imgs/icon-check-dark-gray.svg'
import closeIcon from '@/assets/imgs/icon-close-circle.svg'
import timeIcon from '@/assets/imgs/icon-time.svg'
import nupayIcon from '@/assets/imgs/nupay.svg'

import {
  transactionPaymentMethod,
  transactionType,
} from '@/resources/enums/transactions'

export const DEFAULT_TRANSACTION_PER_PAGE = 30

export const DEFAULT_PAGE_NUMBER = 1

export const ONLINE_PAYMENT_ORDER_DATE_RANGE_DAYS = 31

export const ONLINE_PAYMENT_ORDER_DATE_RANGE_LIMIT =
  ONLINE_PAYMENT_ORDER_DATE_RANGE_DAYS - 1

export const ONLINE_PAYMENT_TRANSACTION_DATE_RANGE_DAYS = 7

export const ONLINE_PAYMENT_TRANSACTION_DATE_RANGE_LIMIT =
  ONLINE_PAYMENT_TRANSACTION_DATE_RANGE_DAYS - 1

export const getPaymentMethod = (paymentMethod: string) =>
  transactionPaymentMethod?.[paymentMethod] ?? null

export const getPaymentMethodIcon = (paymentMethod: string) =>
  ({
    [transactionPaymentMethod.CREDIT_CARD]: creditIcon,
    [transactionPaymentMethod.PIX]: pixIcon,
    [transactionPaymentMethod.NUPAY]: nupayIcon,
    [transactionPaymentMethod.NUPAY_CREDIT]: nupayIcon,
    [transactionPaymentMethod.NUPAY_DEBIT]: nupayIcon,
  })?.[transactionPaymentMethod?.[paymentMethod]] ?? null

export const getStatus = (type: string, status: string) =>
  transactionType?.[type]?.[status] ?? null

export const getStatusColor = (type: string, status: string) => {
  switch (true) {
    case type === 'CREDIT' && status === 'ACCOMPLISHED':
      return 'success'
    case type === 'CREDIT' && status === 'PENDING':
      return 'in-progress'
    default:
      return 'neutral'
  }
}

export const getStatusIcon = (
  type: 'CREDIT' | 'REFUND',
  status: 'ACCOMPLISHED' | 'PENDING'
) =>
  ({
    CREDIT: {
      ACCOMPLISHED: checkIcon,
      PENDING: timeIcon,
    },
    REFUND: {
      ACCOMPLISHED: closeIcon,
      PENDING: closeIcon,
    },
  })?.[type]?.[status] ?? null

export const getCurrentDay = () => new Date()

export const getISOCurrentDay = () => getCurrentDay().toISOString()

export const getLastSevenDays = () => {
  const lastSevenDays = new Date()
  lastSevenDays.setDate(lastSevenDays.getDate() - 6)
  lastSevenDays.setHours(0, 0, 0)
  return lastSevenDays
}

export const getLastThirtyOneDays = () => {
  const lastThirtyOneDays = new Date()
  lastThirtyOneDays.setDate(
    lastThirtyOneDays.getDate() - ONLINE_PAYMENT_ORDER_DATE_RANGE_LIMIT
  )
  lastThirtyOneDays.setHours(0, 0, 0)
  return lastThirtyOneDays
}

export const getISOLastSevenDays = () => {
  return getLastSevenDays().toISOString()
}

export const getFormattedDate = (unformattedDate: string) => {
  const date = new Date(unformattedDate)
  const day = `${date.getDate()}`.padStart(2, '0')
  const month = `${date.getMonth() + 1}`.padStart(2, '0')
  return `${day}/${month}`
}

export const getPlan7DaysWeeklyExplanationOfFees = (
  lastTransferDate: string,
  startPeriod: string,
  endPeriod: string
) => {
  const formattedLastTransferDate = getFormattedDate(lastTransferDate)
  const formattedStartPeriod = getFormattedDate(startPeriod)
  const formattedEndPeriod = getFormattedDate(endPeriod)

  return `${dict.lastTransferOccurrence} ${formattedLastTransferDate} ${dict.referringToThePeriodOfTransfer} ${formattedStartPeriod} ${dict.to} ${formattedEndPeriod}`
}

export const getTitle = (lastTransferDate: string) => {
  const formattedDate = getFormattedDate(lastTransferDate)

  return `${dict.lastTransferOccurrence} ${formattedDate}`
}

export const getPlan7DaysWeeklyTitle = (
  lastTransferDate: string,
  startPeriod: string,
  endPeriod: string
) => {
  const formattedLastTransferDate = getFormattedDate(lastTransferDate)
  const formattedStartPeriod = getFormattedDate(startPeriod)
  const formattedEndPeriod = getFormattedDate(endPeriod)

  return `${dict.lastTransferDay} ${formattedLastTransferDate} ${dict.referringToThePeriod} ${formattedStartPeriod} ${dict.to} ${formattedEndPeriod}`
}

export const getPlanD30Title = (lastTransferDate: string) => {
  const formattedDate = getFormattedDate(lastTransferDate)

  return `${dict.lastTransferDay} ${formattedDate}`
}
